export function getPartnerBrandColors(currentBusiness) {
  const brandColors = currentBusiness?.partner?.brand_colors;

  if (!brandColors || !brandColors.primary) {
    return null;
  }

  return brandColors;
}

export function hasPartnerBrandColors(currentBusiness) {
  return !!getPartnerBrandColors(currentBusiness);
}

export function getBrandPrimaryColor(currentBusiness) {
  return getPartnerBrandColors(currentBusiness)?.primary ?? null;
}

export function getBrandInvoiceColorScheme(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return null;
  }

  const foreground = brandColors.primary_foreground;

  return {
    toHeader: {
      ...getBrandSummaryCardStyle(currentBusiness),
      color: foreground,
    },
    header: {
      ...getBrandSummaryCardStyle(currentBusiness),
      color: foreground,
    },
    addBtn: {
      backgroundColor: brandColors.primary,
      color: foreground,
    },
    createBtn: {
      backgroundColor: brandColors.primary,
      color: foreground,
    },
    newItem: {
      color: brandColors.primary,
    },
  };
}

export const DEFAULT_CHART_COLORS = {
  income: "#2196F3",
  expense: "#F44336",
  profit: "#4CAF50",
};

export function getBrandChartSeriesColors(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return { ...DEFAULT_CHART_COLORS };
  }

  return {
    income: brandColors.primary,
    expense: brandColors.secondary,
    profit: brandColors.ascent || brandColors.accent,
  };
}

export function getBrandChartColors(currentBusiness) {
  const { income, expense, profit } =
    getBrandChartSeriesColors(currentBusiness);

  return [income, expense, profit];
}

export function getBrandExpenseDonutColors(currentBusiness, sliceCount = 6) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return null;
  }

  const palette = [
    brandColors.primary,
    brandColors.secondary,
    brandColors.ascent || brandColors.accent,
  ].filter(Boolean);

  if (!palette.length) {
    return null;
  }

  return Array.from({ length: sliceCount }, (_, index) =>
    palette[index % palette.length],
  );
}

export function getBrandSidebarStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return {};
  }

  return {
    "--brand-primary": brandColors.primary,
    "--brand-primary-foreground": brandColors.primary_foreground,
  };
}

export function getBrandSummaryCardStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return {};
  }

  return {
    backgroundColor: brandColors.primary,
    "--brand-primary-foreground": brandColors.primary_foreground,
  };
}

export function getBrandPrimaryButtonStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return {};
  }

  return {
    "--brand-primary": brandColors.primary,
    "--brand-primary-foreground": brandColors.primary_foreground,
    backgroundColor: brandColors.primary,
    color: brandColors.primary_foreground,
  };
}

export function getBrandPrimaryButtonTextStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors?.primary_foreground) {
    return {};
  }

  return {
    color: brandColors.primary_foreground,
  };
}

export function getBrandIconAvatarStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return {};
  }

  return {
    backgroundColor: brandColors.primary,
  };
}

export function getBrandIconColorStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors) {
    return {};
  }

  return {
    color: brandColors.primary_foreground,
  };
}

export function getBrandSecondaryButtonStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors?.secondary) {
    return {};
  }

  return {
    "--brand-secondary": brandColors.secondary,
    "--brand-secondary-foreground": brandColors.secondary_foreground,
    backgroundColor: brandColors.secondary,
    color: brandColors.secondary_foreground,
    borderColor: brandColors.secondary,
  };
}

export function getBrandSecondaryIconStyle(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors?.secondary_foreground) {
    return {};
  }

  return {
    color: brandColors.secondary_foreground,
  };
}

export function getBrandSecondaryStyleVars(currentBusiness) {
  const brandColors = getPartnerBrandColors(currentBusiness);

  if (!brandColors?.secondary) {
    return {};
  }

  return {
    "--brand-secondary": brandColors.secondary,
  };
}
